import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { PARTNER_TYPE_AGENT } from 'common/partnerConstants';

import {
  MEDIA_QUERY_LARGE_SCREEN,
} from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import {
  HowToTalkToClientsAboutSunroom,
  PartnerAgentOwnerMarketingPageChecklist,
} from 'client/components/PartnerAgentOwnerMarketingPage';

const SrPartnerDashboardMarketingSection = ({
  currentPartner,
  appUrl,
}) => {
  useEffect(() => {
    global.scrollTo(0, 0);
  }, []);

  const isLargeScreen = useMediaQuery({
    query: MEDIA_QUERY_LARGE_SCREEN,
  });

  if (currentPartner.type !== PARTNER_TYPE_AGENT) {
    return null;
  }

  return (
    <SrFlex
      wrap='wrap'
      justify={isLargeScreen ? 'between' : 'center'}
      margin={isLargeScreen ? '90px 0 130px' : '150px 0 130px'}
    >
      <SrBox
        maxWidth='100%'
        boxSizing='border-box'
      >
        <HowToTalkToClientsAboutSunroom
          partner={currentPartner}
          appUrl={appUrl}
        />
      </SrBox>
      <SrBox
        order={isLargeScreen ? -1 : null}
        margin={isLargeScreen ? '31px 0 49px 0' : '31px 0 24px 125px'}
        width={isLargeScreen ? '400px' : null}
      >
        <PartnerAgentOwnerMarketingPageChecklist partner={currentPartner} />
      </SrBox>
    </SrFlex>
  );
};

SrPartnerDashboardMarketingSection.propTypes = {
  currentPartner: PropTypes.object,
  appUrl: PropTypes.string.isRequired,
};

SrPartnerDashboardMarketingSection.displayName = 'SrPartnerDashboardMarketingSection';

export default SrPartnerDashboardMarketingSection;
